import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from '../../styles/styled';
import { Box } from '../layout';
export function TabbedContentContainer({ tabs, activeTabKey, dataTestId, }) {
    return (_jsx(Box, { minHeight: "1px", "data-testid": dataTestId, children: _jsx(ContentWrapper, { children: tabs.find(tab => tab.key === activeTabKey)?.content }) }));
}
const ContentWrapper = styled.div(({ theme }) => ({
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: `${theme.spacing.m} ${theme.spacing.xxs} ${theme.spacing.xxs} ${theme.spacing.xxs}`,
}));
//# sourceMappingURL=tabbed_content_container.js.map